"use client";
//import node module libraries
import { useState } from "react";

export const useToggle = () => {
  const [isToggled, setIsToggled] = useState(false);

  const handleOpen = () => {
    setIsToggled(true);
  };

  const handleClose = () => {
    setIsToggled(false);
  };

  const toggleFunc = () => {
    setIsToggled((prev) => !prev);
  };
  return {
    handleOpen,
    handleClose,
    toggleFunc,
    isToggled,
  };
};
